import React from 'react';
import HeaderDetail from './header-detail';
import {
  ButonCTA,
  Container,
  ContainerFooterFaq,
  TitleCtaFaq,
} from './modal-ddetail-style';

import LOGO_EMPRETEC_ARENA from '../../assets/arena.png';
import LOGO_EMPRETEC_RURAL from '../../assets/rural.png';
import LOGO_EMPRETEC_STARTUP from '../../assets/startup.png';
import LOGO_EMPRETEC_TRADICIONAL from '../../assets/tradicional.png';

import LOGO_EMPRETEC_TRADICIONAL_BLACK from '../../assets/empretec-black-1.png';
import LOGO_EMPRETEC_STARTUP_BLACK from '../../assets/empretec-black-2.png';
import LOGO_EMPRETEC_ARENA_BLACK from '../../assets/empretec-black-3.png';
import LOGO_EMPRETEC_RURAL_BLACK from '../../assets/empretec-black-4.png';

import {
  MAP_EMPRETEC,
  MAP_EMPRETEC_ARENA_FREQUENT_QUESTIONS,
  MAP_EMPRETEC_FREQUENT_QUESTIONS,
  MAP_EMPRETEC_RURAL_FREQUENT_QUESTIONS,
  MAP_EMPRETEC_STARTUP_FREQUENT_QUESTIONS,
} from '../../data/empretecData';
import FaqDetail from './faq-ddetail';
import InformationsDetail from './informtions-detail';

const MAP_LOGO_EMPRETEC = [
  {
    id: 1,
    imgSelected: LOGO_EMPRETEC_TRADICIONAL,
    color: '#0000C9',
    img: LOGO_EMPRETEC_TRADICIONAL_BLACK,
  },
  {
    id: 3,
    imgSelected: LOGO_EMPRETEC_ARENA,
    color: '#801080',
    img: LOGO_EMPRETEC_ARENA_BLACK,
  },
  {
    id: 2,
    imgSelected: LOGO_EMPRETEC_STARTUP,
    color: '#40BBFF',
    img: LOGO_EMPRETEC_STARTUP_BLACK,
  },
  {
    id: 4,
    imgSelected: LOGO_EMPRETEC_RURAL,
    color: '#387F3A',
    img: LOGO_EMPRETEC_RURAL_BLACK,
  },
];
const MAP_FAQ = [
  {
    id: 1,
    title: 'Dúvidas sobre o Empretec',
    list: MAP_EMPRETEC_FREQUENT_QUESTIONS,
    color: '#215DF4',
  },
  {
    id: 4,
    title: 'Dúvidas sobre o Empretec Rural',
    list: MAP_EMPRETEC_RURAL_FREQUENT_QUESTIONS,
    color: '#4FAD4F',
  },
  {
    id: 3,
    title: 'Dúvidas sobre o Empretec Arena',
    list: MAP_EMPRETEC_ARENA_FREQUENT_QUESTIONS,
    color: '#AB40B2',
  },
  {
    id: 2,
    title: 'Dúvidas sobre o Empretec Startup',
    list: MAP_EMPRETEC_STARTUP_FREQUENT_QUESTIONS,
    color: '#8CE0FF',
  },
];
function ModalDetail({ empretecId, closeModal, closeModalToSSubscription }) {
  const [selectedId, setSelectedId] = React.useState(empretecId ?? 1);
  const [empretecSelected, setEmpretecSelected] = React.useState(
    empretecId ?? 1,
  );

  const handleSelect = (id) => {
    setSelectedId(id);
  };

  React.useEffect(() => {
    const empretecSelected = MAP_EMPRETEC.find(
      (e) => e.moduleId === selectedId,
    );
    setEmpretecSelected(empretecSelected);
  }, [selectedId]);

  const [options, setOptions] = React.useState([]);
  const [title, setTitle] = React.useState('');

  React.useEffect(() => {
    const result = MAP_FAQ.find((fq) => fq.id === selectedId);
    setOptions(result.list);
    setTitle(result.title);
  }, [selectedId]);

  const handleClick = (id) => {
    setOptions((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        opened: item.id === id,
      })),
    );
  };

  return (
    <Container>
      <HeaderDetail
        listEmpretecData={MAP_LOGO_EMPRETEC}
        selectedId={selectedId}
        handleSelect={handleSelect}
        closeModal={closeModal}
      />
      <InformationsDetail
        empretecSelected={empretecSelected}
        closeModalToSSubscription={closeModalToSSubscription}
      />

      <FaqDetail
        selectedId={selectedId}
        title={title}
        options={options}
        setOptions={setOptions}
        handleClick={handleClick}
        defaultvalues={MAP_FAQ.find((fq) => fq.id === selectedId).list}
        color={MAP_FAQ.find((fq) => fq.id === selectedId).color}
      />

      <ContainerFooterFaq>
        <TitleCtaFaq>
          Não resta mais dúvida, só vontade.
          <br /> A hora de transformar sua jornada é agora.
        </TitleCtaFaq>

        <ButonCTA
          colorText={selectedId === 2 ? '#000' : '#fff'}
          bgColor={empretecSelected?.bgColorInformations}
          onClick={() => closeModalToSSubscription()}
        >
          {empretecSelected?.textButtonCta}
        </ButonCTA>
      </ContainerFooterFaq>
    </Container>
  );
}

export default ModalDetail;
